import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import { HoldingsDashboardTable } from "modules/HoldingsDashboard/components";
import { CreateUpdateHoldingModal } from "modules/HoldingsDashboard/components/CreateUpdateHoldingModal";
import "modules/HoldingsDashboard/HoldingsDashboard.scss";

import type { Holding } from "models";

export const HoldingsDashboard = () => {
  const [showCreateUpdateHoldingModal, setShowCreateUpdateHoldingModal] = useState(false);
  const [holdingToUpdate, setHoldingToUpdate] = useState<Holding | null>(null);

  const handleShowEditHoldingModal = (holding: Holding) => {
    setShowCreateUpdateHoldingModal(true);
    setHoldingToUpdate(holding);
  };

  const handleCloseCreateUpdateHoldingModal = () => {
    setShowCreateUpdateHoldingModal(false);
    setHoldingToUpdate(null);
  };

  return (
    <>
      <div className="HoldingsDashboard">
        <Can I="create" the="holding">
          <div className="toolbar">
            <Button basic icon className="add-btn" onClick={() => setShowCreateUpdateHoldingModal(true)}>
              <Icon className="plus" />
            </Button>
          </div>
        </Can>
        <HoldingsDashboardTable onShowEditHoldingModal={handleShowEditHoldingModal} />
      </div>

      <CreateUpdateHoldingModal isOpen={showCreateUpdateHoldingModal} holding={holdingToUpdate} onClose={handleCloseCreateUpdateHoldingModal} />
    </>
  );
};
